// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file chat-identity.proto (syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2'
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2'
import type { ImageFormat } from './enums_pb'
import { file_enums } from './enums_pb'
import type { ProfileShowcase } from './profile-showcase_pb'
import { file_profile_showcase } from './profile-showcase_pb'
import type { Message } from '@bufbuild/protobuf'

/**
 * Describes the file chat-identity.proto.
 */
export const file_chat_identity: GenFile =
  /*@__PURE__*/
  fileDesc(
    'ChNjaGF0LWlkZW50aXR5LnByb3RvItICCgxDaGF0SWRlbnRpdHkSDQoFY2xvY2sYASABKAQSEAoIZW5zX25hbWUYAiABKAkSKQoGaW1hZ2VzGAMgAygLMhkuQ2hhdElkZW50aXR5LkltYWdlc0VudHJ5EhQKDGRpc3BsYXlfbmFtZRgEIAEoCRITCgtkZXNjcmlwdGlvbhgFIAEoCRINCgVjb2xvchgGIAEoCRINCgVlbW9qaRgHIAEoCRIhCgxzb2NpYWxfbGlua3MYCCADKAsyCy5Tb2NpYWxMaW5rEh8KF2ZpcnN0X21lc3NhZ2VfdGltZXN0YW1wGAkgASgNEioKEHByb2ZpbGVfc2hvd2Nhc2UYCiABKAsyEC5Qcm9maWxlU2hvd2Nhc2UaPQoLSW1hZ2VzRW50cnkSCwoDa2V5GAEgASgJEh0KBXZhbHVlGAIgASgLMg4uSWRlbnRpdHlJbWFnZToCOAEi6AEKDUlkZW50aXR5SW1hZ2USDwoHcGF5bG9hZBgBIAEoDBIuCgtzb3VyY2VfdHlwZRgCIAEoDjIZLklkZW50aXR5SW1hZ2UuU291cmNlVHlwZRIiCgxpbWFnZV9mb3JtYXQYAyABKA4yDC5JbWFnZUZvcm1hdBIXCg9lbmNyeXB0aW9uX2tleXMYBCADKAwSEQoJZW5jcnlwdGVkGAUgASgIIkYKClNvdXJjZVR5cGUSFwoTVU5LTk9XTl9TT1VSQ0VfVFlQRRAAEg8KC1JBV19QQVlMT0FEEAESDgoKRU5TX0FWQVRBUhACIicKClNvY2lhbExpbmsSDAoEdGV4dBgBIAEoCRILCgN1cmwYAiABKAliBnByb3RvMw',
    [file_enums, file_profile_showcase],
  )

/**
 * ChatIdentity represents the user defined identity associated with their public chat key
 *
 * @generated from message ChatIdentity
 */
export type ChatIdentity = Message<'ChatIdentity'> & {
  /**
   * Lamport timestamp of the message
   *
   * @generated from field: uint64 clock = 1;
   */
  clock: bigint

  /**
   * ens_name is the valid ENS name associated with the chat key
   *
   * @generated from field: string ens_name = 2;
   */
  ensName: string

  /**
   * images is a string indexed mapping of images associated with an identity
   *
   * @generated from field: map<string, IdentityImage> images = 3;
   */
  images: { [key: string]: IdentityImage }

  /**
   * display name is the user set identity
   *
   * @generated from field: string display_name = 4;
   */
  displayName: string

  /**
   * description is the user set description
   *
   * @generated from field: string description = 5;
   */
  description: string

  /**
   * @generated from field: string color = 6;
   */
  color: string

  /**
   * @generated from field: string emoji = 7;
   */
  emoji: string

  /**
   * @generated from field: repeated SocialLink social_links = 8;
   */
  socialLinks: SocialLink[]

  /**
   * first known message timestamp in seconds (valid only for community chats for now)
   * 0 - unknown
   * 1 - no messages
   *
   * @generated from field: uint32 first_message_timestamp = 9;
   */
  firstMessageTimestamp: number

  /**
   * @generated from field: ProfileShowcase profile_showcase = 10;
   */
  profileShowcase?: ProfileShowcase
}

/**
 * Describes the message ChatIdentity.
 * Use `create(ChatIdentitySchema)` to create a new message.
 */
export const ChatIdentitySchema: GenMessage<ChatIdentity> =
  /*@__PURE__*/
  messageDesc(file_chat_identity, 0)

/**
 * ProfileImage represents data associated with a user's profile image
 *
 * @generated from message IdentityImage
 */
export type IdentityImage = Message<'IdentityImage'> & {
  /**
   * payload is a context based payload for the profile image data,
   * context is determined by the `source_type`
   *
   * @generated from field: bytes payload = 1;
   */
  payload: Uint8Array

  /**
   * source_type signals the image payload source
   *
   * @generated from field: IdentityImage.SourceType source_type = 2;
   */
  sourceType: IdentityImage_SourceType

  /**
   * image_format signals the image format and method of parsing the payload
   *
   * @generated from field: ImageFormat image_format = 3;
   */
  imageFormat: ImageFormat

  /**
   * encryption_keys is a list of encrypted keys that can be used to decrypted an encrypted payload
   *
   * @generated from field: repeated bytes encryption_keys = 4;
   */
  encryptionKeys: Uint8Array[]

  /**
   * encrypted signals the encryption state of the payload, default is false.
   *
   * @generated from field: bool encrypted = 5;
   */
  encrypted: boolean
}

/**
 * Describes the message IdentityImage.
 * Use `create(IdentityImageSchema)` to create a new message.
 */
export const IdentityImageSchema: GenMessage<IdentityImage> =
  /*@__PURE__*/
  messageDesc(file_chat_identity, 1)

/**
 * SourceType are the predefined types of image source allowed
 *
 * @generated from enum IdentityImage.SourceType
 */
export enum IdentityImage_SourceType {
  /**
   * @generated from enum value: UNKNOWN_SOURCE_TYPE = 0;
   */
  UNKNOWN_SOURCE_TYPE = 0,

  /**
   * RAW_PAYLOAD image byte data
   *
   * @generated from enum value: RAW_PAYLOAD = 1;
   */
  RAW_PAYLOAD = 1,

  /**
   * ENS_AVATAR uses the ENS record's resolver get-text-data.avatar data
   * The `payload` field will be ignored if ENS_AVATAR is selected
   * The application will read and parse the ENS avatar data as image payload data, URLs will be ignored
   * The parent `ChatMessageIdentity` must have a valid `ens_name` set
   *
   * @generated from enum value: ENS_AVATAR = 2;
   */
  ENS_AVATAR = 2,
}

/**
 * Describes the enum IdentityImage.SourceType.
 */
export const IdentityImage_SourceTypeSchema: GenEnum<IdentityImage_SourceType> =
  /*@__PURE__*/
  enumDesc(file_chat_identity, 1, 0)

/**
 * SocialLinks represents social link assosiated with given chat identity (personal/community)
 *
 * @generated from message SocialLink
 */
export type SocialLink = Message<'SocialLink'> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string

  /**
   * @generated from field: string url = 2;
   */
  url: string
}

/**
 * Describes the message SocialLink.
 * Use `create(SocialLinkSchema)` to create a new message.
 */
export const SocialLinkSchema: GenMessage<SocialLink> =
  /*@__PURE__*/
  messageDesc(file_chat_identity, 2)
